import { render, staticRenderFns } from "./onBusiness.vue?vue&type=template&id=0466bbb0&scoped=true"
import script from "./onBusiness.vue?vue&type=script&lang=js"
export * from "./onBusiness.vue?vue&type=script&lang=js"
import style0 from "./onBusiness.vue?vue&type=style&index=0&id=0466bbb0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0466bbb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0466bbb0')) {
      api.createRecord('0466bbb0', component.options)
    } else {
      api.reload('0466bbb0', component.options)
    }
    module.hot.accept("./onBusiness.vue?vue&type=template&id=0466bbb0&scoped=true", function () {
      api.rerender('0466bbb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/personnel/onBusiness.vue"
export default component.exports